// client/src/components/Routing/TerritoryWorkbench/WeekViz/weekDayBars.js

export const BLOCK_COLORS = {
  work:  '#2f7a3e',
  drive: '#c66a45',
  break: '#3454c1',
  lunch: '#8b5cf6'
}

export function formatTimeFromMinutes (totalMin) {
  if (!Number.isFinite(totalMin)) return ''
  const hours24 = Math.floor(totalMin / 60)
  const mins = totalMin % 60
  const hours12 = hours24 % 12 === 0 ? 12 : hours24 % 12
  const suffix = hours24 < 12 ? 'a' : 'p'
  return mins === 0
    ? `${hours12}${suffix}`
    : `${hours12}:${String(mins).padStart(2, '0')}${suffix}`
}

export function blockSegments (blocks) {
  const total = blocks.reduce((sum, b) => sum + (b.min || 0), 0)
  if (total === 0) return []
  return blocks.map(b => ({
    kind: b.kind,
    min: b.min,
    color: BLOCK_COLORS[b.kind] || '#999',
    widthPct: (b.min / total) * 100
  }))
}
